/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {SyntheticEvent} from 'react';
import JsonView from 'react-pretty-json';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import EditorDialog from '@ion/dls/src/editors/EditorDialog';
import styles from '@ion/dls/src/editors/editorStyles';
import {useExtendStyles} from '@ion/dls/src/hooks/useExtendStyles';

export interface EventViewDialogProps {
  selectedEvent: GenericObject;
  onCloseDialog?: (event: SyntheticEvent<{}, Event>) => void;
}

const overrides = () => ({
  form : {
    height : '100%'
  }
});

export const EventViewDialog = ({
  selectedEvent,
  onCloseDialog
}: EventViewDialogProps) => {
  const classes = useExtendStyles(styles, overrides)();

  return (
    <EditorDialog open
      dialogTitle={translate('admin-devices:view.events.grid.deviceHistory')}
      onCloseDialog={onCloseDialog}
      onCancelDialog={onCloseDialog}
      styleOverrides={overrides}
      omitActions>
      <form className={classes.form}>
        <pre><JsonView json={selectedEvent || ''}/></pre>
      </form>
    </EditorDialog>
  );
};

export default EventViewDialog;
